import React, {useEffect} from 'react';
import {generateAIVideosText} from '../generateAIVideosText';
import YesNoOption from '../../../../uiToolkit/Inputs/YesNoOption';
import TextInput from '../../../../uiToolkit/Inputs/TextInput';
import ToggleSwitch from '../../../../uiToolkit/Inputs/ToggleSwitch';
import {
  ACK_NODE_OPTIONS,
  ASSESMENT_OPTIONS,
  BRANCHING_OPTIONS,
} from '../../GenerateMicrolesson/conf';
import NumbersInput from '../../../../uiToolkit/Inputs/NumbersInput';
import featureFlags, {FeatureFlagName} from '../../../../utils/featureFlags';

interface Props {
  generateMicrolesson: boolean;
  setGenerateMicrolesson: (value: boolean) => void;
  microlessonTitle: string;
  setMicrolessonTitle: (value: string) => void;
  includeBranching: boolean;
  setIncludeBranching: (value: boolean) => void;
  includeGrading: boolean;
  setIncludeGrading: (value: boolean) => void;
  passingScore?: number;
  setPassingScore: (value: number | undefined) => void;
  setEnableAckNode: (value: boolean) => void;
  generateMicroreels: boolean;
  setGenerateMicroreels: (value: boolean) => void;
}

const GenerateMicrolessonStep = React.memo(
  ({
    generateMicrolesson,
    setGenerateMicrolesson,
    microlessonTitle,
    setMicrolessonTitle,
    includeBranching,
    setIncludeBranching,
    includeGrading,
    setIncludeGrading,
    passingScore,
    setPassingScore,
    setEnableAckNode,
    generateMicroreels,
    setGenerateMicroreels,
  }: Props) => {
    useEffect(() => {
      setEnableAckNode(!includeGrading);
    }, [includeGrading, setEnableAckNode]);

    return (
      <div className="StepContainer">
        <h5 className="StepTitle">
          {generateAIVideosText.generateMicrolessonStep_pageTitle}
        </h5>
        <h5 className="SectionTitle mt-4">
          {
            generateAIVideosText.generateMicrolessonStep_generateMicrolessonLabel
          }
        </h5>
        <p>
          <YesNoOption
            onSelect={setGenerateMicrolesson}
            className="OptionsSection"
            value={generateMicrolesson}
          />
        </p>
        {generateMicrolesson && (
          <>
            <p className="LessonGenVideoTitle">
              {generateAIVideosText.generateMicrolessonStep_titleField}
              <span className="MandatoryIndicator">*</span>
            </p>
            <p className="LessonGenVideoSubTitle">
              {generateAIVideosText.generateMicrolessonStep_titleDescription}
            </p>
            <TextInput
              value={microlessonTitle}
              placeholder={
                generateAIVideosText.generateMicrolessonStep_titleField
              }
              onChange={setMicrolessonTitle}
              disabled={!generateMicrolesson}
            />

            <p className="LessonGenVideoTitle">
              {generateAIVideosText.generateMicrolessonStep_includeBranching}
            </p>
            <p className="LessonGenVideoSubTitle">
              {generateAIVideosText.generateMicrolessonStep_branchingSubtitle}
            </p>
            <ToggleSwitch
              options={BRANCHING_OPTIONS}
              selectedKey={includeBranching ? '1' : '0'}
              onChange={v => setIncludeBranching(v === '1')}
              disabled={!generateMicrolesson}
            />
            <p className="LessonGenVideoTitle">
              {generateAIVideosText.generateMicrolessonStep_includeGrading}
            </p>
            <p className="LessonGenVideoSubTitle">
              {generateAIVideosText.generateMicrolessonStep_assesmentSubtitle}
            </p>
            <ToggleSwitch
              options={ASSESMENT_OPTIONS}
              selectedKey={includeGrading ? '1' : '0'}
              onChange={v => {
                const nextIncludeGrading = v === '1';
                setIncludeGrading(nextIncludeGrading);
                if (nextIncludeGrading) {
                  setEnableAckNode(false);
                } else {
                  setEnableAckNode(true);
                }
              }}
              disabled={!generateMicrolesson}
            />
            {includeGrading && (
              <>
                <p className="LessonGenVideoTitle">
                  {generateAIVideosText.generateMicrolessonStep_passingScore}
                  <span className="MandatoryIndicator">*</span>
                </p>
                <p className="LessonGenVideoSubTitle">
                  {
                    generateAIVideosText.generateMicrolessonStep_passingScoreSubtitle
                  }
                </p>
                <NumbersInput
                  value={passingScore}
                  setValue={setPassingScore}
                  disabled={!includeGrading || !generateMicrolesson}
                  className="LessonGenPassingScore"
                  minValue={0}
                  maxValue={100}
                />
              </>
            )}
            {featureFlags.get(FeatureFlagName.AcknowledgmentNode) && (
              <>
                <p className="LessonGenVideoTitle">
                  {generateAIVideosText.generateMicrolessonStep_enableAckNode}
                </p>
                <p className="LessonGenVideoSubTitle">
                  {
                    generateAIVideosText.generateMicrolessonStep_enableAckNodeSubtitle
                  }
                </p>
                <ToggleSwitch
                  options={ACK_NODE_OPTIONS}
                  selectedKey={includeGrading ? '0' : '1'}
                  disabled
                />
              </>
            )}
            <h5 className="SectionTitle mt-4">
              {
                generateAIVideosText.generateMicrolessonStep_generateMicroreelsLabel
              }
            </h5>
            <p>
              <YesNoOption
                onSelect={setGenerateMicroreels}
                className="OptionsSection"
                value={generateMicroreels}
              />
            </p>
          </>
        )}
      </div>
    );
  },
);

export default GenerateMicrolessonStep;
